import { SelectOptions } from '@/ui/types';
import { Days, Repeat } from '@/entities/rrule/constants';
import { t } from '@/ui/i18n/i18n';

export const useRepeatOptions = () => {
  const repeatOptions: SelectOptions<string> = [
    {
      value: Repeat.Daily,
      label: t('schedules.repeat.daily'),
    },
    {
      value: Repeat.Weekday,
      label: t('schedules.repeat.every-weekday'),
    },
    {
      value: Repeat.Weekly,
      label: t('schedules.repeat.weekly'),
    },
    {
      value: Repeat.Monthly,
      label: t('schedules.repeat.monthly'),
    },
    {
      value: Repeat.Yearly,
      label: t('schedules.repeat.yearly'),
    },
    {
      value: Repeat.NoRepeat,
      label: t('schedules.repeat.no-repeat'),
    },
    {
      value: Repeat.Custom,
      label: t('schedules.repeat.custom'),
    },
  ];

  const frequencyOptions: SelectOptions<string> = [
    {
      value: Repeat.Weekly,
      label: t('schedules.repeat.weekly'),
    },
    {
      value: Repeat.Monthly,
      label: t('schedules.repeat.monthly'),
    },
  ];

  const dayOptions: SelectOptions<string> = [
    {
      value: Days.MO,
      label: t('schedules.days.abbreviated.monday'),
    },
    {
      value: Days.TU,
      label: t('schedules.days.abbreviated.tuesday'),
    },
    {
      value: Days.WE,
      label: t('schedules.days.abbreviated.wednesday'),
    },
    {
      value: Days.TH,
      label: t('schedules.days.abbreviated.thursday'),
    },
    {
      value: Days.FR,
      label: t('schedules.days.abbreviated.friday'),
    },
    {
      value: Days.SA,
      label: t('schedules.days.abbreviated.saturday'),
    },
    {
      value: Days.SU,
      label: t('schedules.days.abbreviated.sunday'),
    },
  ];

  const monthPositionOptions: SelectOptions = [
    {
      value: 1,
      label: t('schedules.position.first'),
    },
    {
      value: 2,
      label: t('schedules.position.second'),
    },
    {
      value: 3,
      label: t('schedules.position.third'),
    },
    {
      value: 4,
      label: t('schedules.position.fourth'),
    },
    {
      value: 5,
      label: t('schedules.position.fifth'),
    },
    {
      value: -1,
      label: t('schedules.position.last'),
    },
  ];

  const dayFrequencyOptions: SelectOptions<string> = [
    {
      value: Days.MO,
      label: t('schedules.days.monday'),
    },
    {
      value: Days.TU,
      label: t('schedules.days.tuesday'),
    },
    {
      value: Days.WE,
      label: t('schedules.days.wednesday'),
    },
    {
      value: Days.TH,
      label: t('schedules.days.thursday'),
    },
    {
      value: Days.FR,
      label: t('schedules.days.friday'),
    },
    {
      value: Days.SA,
      label: t('schedules.days.saturday'),
    },
    {
      value: Days.SU,
      label: t('schedules.days.sunday'),
    },
    {
      value: Repeat.Day,
      label: t('schedules.repeat.day'),
    },
    {
      value: Repeat.Weekday,
      label: t('schedules.repeat.weekday'),
    },
    {
      value: Repeat.WeekendDay,
      label: t('schedules.repeat.weekend-day'),
    },
  ];

  return {
    repeatOptions,
    dayOptions,
    dayFrequencyOptions,
    frequencyOptions,
    monthPositionOptions,
  };
};
